module.exports = __webpack_public_path__ + "media/images/gifts/movement/sug_movimento_9-cd3a0b637c438d36febb7a0804664656.jpg";